import { Box, Grid, Typography } from '@mui/material'
import { home } from '@/content/copy'
import { colors, fonts } from '@/theme'
import { Section } from '@/components/ui/Section'
import { Eyebrow } from '@/components/ui/Eyebrow'
import { Reveal } from '@/components/motion/Reveal'

/** Editorial opening statement — oversized display type, asymmetric two-column composition. */
export function Manifesto() {
  return (
    <Section>
      <Grid container spacing={{ xs: 3, md: 8 }}>
        <Grid size={{ xs: 12, md: 4 }}>
          <Reveal>
            <Eyebrow dot>Our purpose</Eyebrow>
            <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: 260 }}>
              Forged for the people who build, weld and forge — where safety is non-negotiable.
            </Typography>
          </Reveal>
        </Grid>
        <Grid size={{ xs: 12, md: 8 }}>
          <Reveal>
            <Typography
              component="h2"
              sx={{
                fontFamily: fonts.display,
                textTransform: 'uppercase',
                fontWeight: 600,
                letterSpacing: '0.01em',
                lineHeight: 0.95,
                color: colors.white,
                fontSize: { xs: 44, sm: 60, md: 80, lg: 92 },
              }}
            >
              {home.introTitle}
            </Typography>
          </Reveal>
          <Reveal delay={0.06}>
            <Box sx={{ width: 56, height: 3, bgcolor: colors.gold, my: { xs: 3, md: 4 } }} />
            <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: 620 }}>
              {home.introBody}
            </Typography>
          </Reveal>
        </Grid>
      </Grid>
    </Section>
  )
}
